module.exports = __webpack_public_path__ + "img/LockIcon.60dff9a2.svg";